import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as i } from "react";
import { I as r } from "../../../../IconBase-CxZyIWw2.js";
const a = i((c, e) => /* @__PURE__ */ s.jsx(
  r,
  {
    ref: e,
    ...c,
    image: (l) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...l,
        children: [
          /* @__PURE__ */ s.jsxs("g", { clipPath: "url(#clip0_2974_4134)", children: [
            /* @__PURE__ */ s.jsxs(
              "mask",
              {
                id: "mask0_2974_4134",
                width: 32,
                height: 24,
                x: 8,
                y: 12,
                maskUnits: "userSpaceOnUse",
                style: {
                  maskType: "alpha"
                },
                children: [
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M15.25 20.34c-1.83 0-3.32 1.49-3.32 3.32s1.49 3.32 3.32 3.32 3.32-1.49 3.32-3.32-1.49-3.32-3.32-3.32m0 5.15c-1 0-1.82-.82-1.82-1.82a1.82 1.82 0 1 1 1.82 1.82M24 20.34c-1.83 0-3.32 1.49-3.32 3.32s1.49 3.32 3.32 3.32 3.32-1.49 3.32-3.32-1.49-3.32-3.32-3.32m0 5.15c-1 0-1.82-.82-1.82-1.82S23 21.84 24 21.84s1.82.82 1.82 1.82S25 25.49 24 25.49M32.75 20.34c-1.83 0-3.32 1.49-3.32 3.32s1.49 3.32 3.32 3.32 3.32-1.49 3.32-3.32-1.49-3.32-3.32-3.32m0 5.15c-1 0-1.82-.82-1.82-1.82a1.82 1.82 0 0 1 3.64 0c0 1-.82 1.82-1.82 1.82"
                    }
                  ),
                  /* @__PURE__ */ s.jsx(
                    "path",
                    {
                      fill: "currentColor",
                      d: "M32.61 12H15.39C11.31 12 8 15.31 8 19.39v15.19c0 .41.34.75.75.75h23.86c4.07 0 7.39-3.31 7.39-7.39v-8.55c0-4.08-3.31-7.39-7.39-7.39m5.89 15.94c0 3.25-2.64 5.89-5.89 5.89H9.5V19.39c0-3.25 2.64-5.89 5.89-5.89h17.23c3.25 0 5.89 2.64 5.89 5.89v8.55z"
                    }
                  )
                ]
              }
            ),
            /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_4134)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M1.121.057h46.391v46.391H1.121z" }) })
          ] }),
          /* @__PURE__ */ s.jsx("defs", { children: /* @__PURE__ */ s.jsx("clipPath", { id: "clip0_2974_4134", children: /* @__PURE__ */ s.jsx("path", { fill: "#fff", d: "M0 0h48v48H0z" }) }) })
        ]
      }
    )
  }
));
a.displayName = "AgencyMessageIcon";
export {
  a as AgencyMessageIcon,
  a as default
};
//# sourceMappingURL=index.js.map
